import { Component, computed, ElementRef, input, output, signal, viewChild } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReferenceElement } from '@floating-ui/dom';
import { map, switchMap } from 'rxjs';
import { ButtonComponent } from 'app/shared/components/button/button.component';
import { CheckboxInputComponent } from 'app/shared/components/checkbox-input/checkbox-input.component';
import { IbanInputComponent } from 'app/shared/components/iban-input/iban-input.component';
import { PopoverComponent } from 'app/shared/components/popover/popover.component';

@Component({
  selector: 'ez-sepa-input-box',
  imports: [
    CheckboxInputComponent,
    ButtonComponent,
    FormsModule,
    ReactiveFormsModule,
    PopoverComponent,
    IbanInputComponent,
  ],
  templateUrl: './sepa-input-box.component.html',
  styleUrl: './sepa-input-box.component.scss',
})
export class SepaInputBoxComponent {
  readonly sepaInfoEl = viewChild.required<ElementRef>('sepaInfo');
  readonly sepaFormGroup = input.required<FormGroup>();
  readonly backToOverview = output();
  readonly submitForm = output();

  readonly anchor = computed<ReferenceElement>(() => this.sepaInfoEl().nativeElement);
  readonly showPopover = signal(false);

  // The parent sets these errors from its submit callback, so nothing else notifies this view.
  readonly errorMessage = toSignal(
    toObservable(this.sepaFormGroup).pipe(
      switchMap((sepaFormGroup) => sepaFormGroup.events),
      map(() => (this.sepaFormGroup().errors ? 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.' : null)),
    ),
    { initialValue: null },
  );

  onClickSepaInfo() {
    this.showPopover.update((shown) => !shown);
  }

  onBackToOverview() {
    this.backToOverview.emit();
  }

  onSubmit() {
    this.submitForm.emit();
  }
}
